import {
	ADD_ONS,
	INCLUDED,
	NOT_INCLUDED,
} from '@/components/BillingPage/Sections/membership'
import { Ledger, numbered, plus } from '@/ui/core/ledger'
import { SheetTitle } from '@/ui/core/sheet'
import { VStack } from '@/ui/core/stack'
import { Text } from '@/ui/core/typography'
import { View } from 'react-native'

const LABEL_GAP = 14

const Caps = ({ children }: { children: string }) => (
	<Text size="body3" tone="soft" className="uppercase tracking-[0.08em]">
		{children}
	</Text>
)

/**
 * What the membership covers, and what it does not. The plan's own facts — price, status, renewal
 * — are on the tile that opens this sheet, so the sheet is only ever about the benefits, which
 * are the same for everyone on the plan.
 */
export const MembershipSheet = () => (
	<View className="pt-2">
		{/* The same tick Home's tile carries, so the mark is the same wherever this sheet is
		    reached from and a member meets one thing rather than two. The sparkle it replaced is
		    the whitening kit's own, one tile to the right. */}
		<SheetTitle glyph="check">Your Membership</SheetTitle>

		{/* Set in past the title's own inset, so the ledger reads as held under the sheet's name
		    rather than starting level with it. The air above the first label is the title's now,
		    so every sheet has it. The foot carries enough to clear the home indicator with the
		    last paragraph above it. */}
		<VStack gap={24} className="px-6 pb-8">
			<VStack gap={LABEL_GAP}>
				<Caps>What&rsquo;s included</Caps>
				<Ledger items={INCLUDED} mark={numbered} />
			</VStack>

			<VStack gap={LABEL_GAP}>
				<Caps>Add on any time</Caps>
				<Ledger items={ADD_ONS} mark={plus} />
			</VStack>

			<VStack gap={LABEL_GAP}>
				<Caps>The rest</Caps>
				<Text size="body1">{NOT_INCLUDED}</Text>
			</VStack>
		</VStack>
	</View>
)
